import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import Error from '@components/Error'

export default function ErrorWrapper(properties) {
  return <ErrorBoundary FallbackComponent={Error}>{properties.children}</ErrorBoundary>
}
